module.exports = __webpack_public_path__ + "static/media/tobe_uploaded.1df3cb1c.png";